function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["active", "block", "classes", "className", "color", "disabled", "href", "iconName", "isLoading", "labelDirection", "onClick", "size", "to"],
  _excluded2 = ["active", "block", "classes", "className", "color", "disabled", "iconName", "isLoading", "labelDirection", "onClick", "size", "type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import cx from "classnames";
import { useButtonClasses } from "../components/ThemeContext.js";
import { useAnimationProps } from "../components/Animation.js";
export var getClassName = function getClassName(ownProps, animationProps, classes) {
  return cx(classes.btn, classes[ownProps.size], classes[ownProps.color], ownProps.className, ownProps.block === true && classes.block, "block-".concat(ownProps.block) in classes && classes["block-".concat(ownProps.block)], ownProps.disabled && classes.disabled, ownProps.isLoading && classes.disabled, ownProps.active && classes.active, animationProps.clicked && classes.clicked);
};
var getContainerClassName = function getContainerClassName(ownProps, animationProps, classes) {
  return cx(classes.container, ownProps.className, ownProps.disabled && classes.disabled, ownProps.active && classes.active, animationProps.clicked && classes.clicked);
};
var mergeCallbacks = function mergeCallbacks() {
  for (var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++) {
    callbacks[_key] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _forEachInstanceProperty(callbacks).call(callbacks, function (callback) {
      if (typeof callback === 'function') {
        callback.apply(void 0, args);
      }
    });
  };
};
var disabledProps = {
  tabIndex: '-1',
  role: 'button',
  'aria-disabled': 'true'
};
var disabledClickHandler = function disabledClickHandler(evt) {
  evt.preventDefault();
};
var handleLinkProps = function handleLinkProps(ownProps, animationProps, isContainer, linkStyles) {
  var active = ownProps.active,
    block = ownProps.block,
    classes = ownProps.classes,
    className = ownProps.className,
    color = ownProps.color,
    disabled = ownProps.disabled,
    href = ownProps.href,
    iconName = ownProps.iconName,
    isLoading = ownProps.isLoading,
    labelDirection = ownProps.labelDirection,
    ownOnClick = ownProps.onClick,
    size = ownProps.size,
    to = ownProps.to,
    passThroughProps = _objectWithoutProperties(ownProps, _excluded);
  var isDisabled = disabled || isLoading || !href && !to;
  var additionalProps = isDisabled ? disabledProps : {
    href: href,
    to: to
  };
  var onClick = isDisabled ? disabledClickHandler : mergeCallbacks(animationProps.onClick, ownOnClick);
  var classNameFunc = isContainer ? getContainerClassName : getClassName;
  return _objectSpread(_objectSpread(_objectSpread({}, passThroughProps), additionalProps), {}, {
    onClick: onClick,
    className: classNameFunc(ownProps, animationProps, linkStyles)
  });
};
var handleButtonProps = function handleButtonProps(ownProps, animationProps, isContainer, buttonStyles) {
  var active = ownProps.active,
    block = ownProps.block,
    classes = ownProps.classes,
    className = ownProps.className,
    color = ownProps.color,
    disabled = ownProps.disabled,
    iconName = ownProps.iconName,
    isLoading = ownProps.isLoading,
    labelDirection = ownProps.labelDirection,
    ownOnClick = ownProps.onClick,
    size = ownProps.size,
    type = ownProps.type,
    passThroughProps = _objectWithoutProperties(ownProps, _excluded2);
  var isDisabled = isLoading || disabled;
  var classNameFunc = isContainer ? getContainerClassName : getClassName;
  return _objectSpread(_objectSpread({}, passThroughProps), {}, {
    'aria-disabled': isDisabled,
    className: classNameFunc(ownProps, animationProps, buttonStyles),
    disabled: isDisabled,
    onClick: mergeCallbacks(animationProps.onClick, ownOnClick),
    type: type
  });
};
export var useButtonProps = function useButtonProps(ownProps, isContainer) {
  var animationProps = useAnimationProps();
  var classes = useButtonClasses(ownProps.classes);
  return handleButtonProps(ownProps, animationProps, isContainer, classes);
};
export var useLinkProps = function useLinkProps(ownProps, isContainer) {
  var animationProps = useAnimationProps();
  var classes = useButtonClasses(ownProps.classes);
  return handleLinkProps(ownProps, animationProps, isContainer, classes);
};
export var limitPropUsageToTertiaryButtons = function limitPropUsageToTertiaryButtons(propType) {
  return function (props, propName) {
    if (props[propName] && props.color !== 'tertiary') {
      return new Error("The ".concat(propName, " prop is only available if the `color` prop is set to \"tertiary\"."));
    }
    for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      rest[_key3 - 2] = arguments[_key3];
    }
    return propType.apply(void 0, [props, propName].concat(rest));
  };
};